import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { attachScrollTriggerOrPlayNow } from "../utils/scrollTriggerHelpers";

gsap.registerPlugin(ScrollTrigger);

/**
 * Griglia block animation.
 *
 * Trigger: ScrollTrigger one-shot all'entrata in viewport (top 85%).
 *
 * Sequenza per ogni card (in stagger 0.12s):
 *   - Card: fade alpha + scale leggero 1.02→1 (1.0s, power2.out)
 *   - Numero: fade-up + blur, +0.2s (tween diretto, no SplitText —
 *     il numero "01" è 1 sola riga, lo split è inutile)
 *   - Titolo: fade-up + blur, +0.3s
 *
 * Hover gestito da CSS (vedi griglia.scss).
 */

const prefersReducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const initGrigliaBlock = (block) => {
  const cards = block.querySelectorAll("[data-griglia-card]");
  if (!cards.length) return;

  // Reduced motion: niente animazione
  if (prefersReducedMotion()) {
    block.setAttribute("data-griglia-ready", "true");
    return;
  }

  // Stato iniziale per tutti gli elementi (card, numero, titolo)
  gsap.set(cards, { opacity: 0, scale: 1.02, transformOrigin: "center center" });

  cards.forEach((card) => {
    const numberEl = card.querySelector("[data-griglia-number]");
    const title = card.querySelector("[data-griglia-title]");

    if (numberEl) {
      gsap.set(numberEl, { opacity: 0, y: 16, filter: "blur(4px)" });
    }
    if (title) {
      gsap.set(title, { opacity: 0, y: 16, filter: "blur(6px)" });
    }
  });

  // Timeline master (paused, attiva via helper)
  const tl = gsap.timeline({ paused: true });

  cards.forEach((card, idx) => {
    const cardStart = idx * 0.12;
    const numberEl = card.querySelector("[data-griglia-number]");
    const title = card.querySelector("[data-griglia-title]");

    // Card: fade alpha + scale
    tl.to(card, {
      opacity: 1,
      scale: 1,
      duration: 1.0,
      ease: "power2.out",
    }, cardStart);

    // Numero: fade-up + blur (diretto, no SplitText)
    if (numberEl) {
      tl.to(numberEl, {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 1.0,
        ease: "power2.out",
      }, cardStart + 0.5);
    }

    // Titolo: fade-up + blur
    if (title) {
      tl.to(title, {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 0.8,
        ease: "power2.out",
      }, cardStart + 1);
    }
  });

  attachScrollTriggerOrPlayNow(tl, {
    trigger: block,
    onComplete: () => block.setAttribute("data-griglia-ready", "true"),
  });
};

const initAllGriglia = () => {
  const blocks = document.querySelectorAll("[data-griglia-block]");
  blocks.forEach(initGrigliaBlock);
};

export default () => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllGriglia);
  } else {
    initAllGriglia();
  }
};